import React from 'react';
import { IconButton, Badge, Avatar, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    main: props => ({
        border: `1px solid ${theme.palette.action.focus}`,
        backgroundColor: theme.palette.background.default,
        color: theme.palette.common.black,
        width: theme.spacing(props.size * 2),
        height: theme.spacing(props.size * 2)
    }),
    content: props => ({
        border: `1px solid ${theme.palette.action.focus}`,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.common.black,
        width: theme.spacing(props.size),
        height: theme.spacing(props.size),
        '& svg': {
            fontSize: theme.spacing(props.size)
        }
    })
}));

export function BadgeButton({ main = '', content = '', size = 3, disabled = false, ...rest }) {
    const classes = useStyles({ size });

    const disabledStyle = {
        opacity: 0.5,
        pointerEvents: 'none'
    };

    return (
        <IconButton edge="end" size="small" disabled={disabled} {...rest}>
            <Badge
                overlap="circular"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                badgeContent={
                    <Avatar className={classes.content} style={disabled ? disabledStyle : {}}>
                        {content}
                    </Avatar>
                }
            >
                <Avatar className={classes.main} style={disabled ? disabledStyle : {}}>
                    {main}
                </Avatar>
            </Badge>
        </IconButton>
    );
}
